module.exports = "https://pearup-project-assets.s3.eu-central-1.amazonaws.com/scratch/assets/4a0bf6dfba5b6bfaa0032016204f6ea9.png";